const SearchOrderTable = () => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover w-100">
        <thead className="table-dark">
          <tr>
            <td>#</td>
            <td>Inv#</td>
            <td>Date</td>
            <td>Order By</td>
            <td>Description</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>2</td>
            <td>
              September 03, 2020 <br />
              <a href="#">View</a> | <a href="#">Edit</a>
            </td>
            <td>Ceo</td>
            <td></td>
          </tr>
          <tr>
            <td>2</td>
            <td>1</td>
            <td>
              September 03, 2020 <br />
              <a href="#">View</a> | <a href="#">Edit</a>
            </td>
            <td>Ca</td>
            <td>Saria</td>
          </tr>
        </tbody>
        <thead className="table-dark">
          <tr>
            <td>#</td>
            <td>Inv#</td>
            <td>Date</td>
            <td>Order By</td>
            <td>Description</td>
          </tr>
        </thead>
      </table>
    </div>
  );
};

export default SearchOrderTable;
